/**
 * Company Card components for the SCAD system
 * Reusable styled components for company cards across the application
 */

import styled from 'styled-components';

export const CompanyCard = styled.div`
  background-color: #FFFFFF;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  transition: transform 0.3s, box-shadow 0.3s;
  display: flex;
  flex-direction: column;
  height: 100%;
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
`;

export const CompanyHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

export const CompanyLogo = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 8px;
  object-fit: cover;
  margin-right: 16px;
`;

export const CompanyLogoLarge = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 8px;
  object-fit: cover;
`;

export const CompanyInfo = styled.div`
  flex: 1;
`;

export const CompanyName = styled.h3`
  margin: 0 0 4px 0;
  font-size: 18px;
  color: #263238;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CompanyIndustry = styled.div`
  color: #546E7A;
  font-size: 14px;
  margin-bottom: 4px;
`;

export const CompanySize = styled.div`
  color: #546E7A;
  font-size: 14px;
`;

export const CompanyBody = styled.div`
  flex: 1;
  margin-bottom: 16px;
`;

export const CompanyDescription = styled.p`
  color: #263238;
  font-size: 14px;
  margin: 0 0 16px 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const InterestTagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
`;

export const InterestTag = styled.span`
  background-color: #E8EAF6;
  color: #3F51B5;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 14px;
  white-space: nowrap;
`;

export const CompanyFooter = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: auto;
`;

export const MatchPercentBadge = styled.span`
  background-color: ${props => {
    const match = props.matchPercentage;
    if (match >= 90) return '#4CAF50';
    if (match >= 75) return '#FFC107';
    return '#546E7A';
  }};
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: bold;
`;

// Named export object to fix anonymous default export warning
const companyCardComponents = {
  CompanyCard,
  CompanyHeader,
  CompanyLogo,
  CompanyLogoLarge,
  CompanyInfo,
  CompanyName,
  CompanyIndustry,
  CompanySize,
  CompanyBody,
  CompanyDescription,
  InterestTagsContainer,
  InterestTag,
  CompanyFooter,
  MatchPercentBadge
};

export default companyCardComponents;
